/**
 * Copyright (c) Microsoft Corporation. All rights reserved.  
 * Licensed under the MIT License.
 */
import * as React from 'react'
import { TipType } from '../ToolTips/ToolTips'
import HelpIcon from '../HelpIcon'
import * as OF from 'office-ui-fabric-react'

export interface IDropdownWithTipProps extends OF.IDropdownProps {
    tipType: TipType
}

class DropdownWithTip extends OF.BaseComponent<IDropdownWithTipProps, OF.IDropdownState> {
    render() {
        const { label, tipType, ...dropdownProps } = this.props

        return (
            <div>
                <OF.Label className="cl-label">{label}
                    <HelpIcon tipType={tipType} />
                </OF.Label>
                <OF.Dropdown
                    {...dropdownProps}
                    ariaLabel={label}
                    label={undefined}
                />
            </div>
        )
    }
}

export default DropdownWithTip


// WEBPACK FOOTER //
// ./src/components/tipComponents/DropdownWithTip.tsx